package net.frozenbit.games.soundgame.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.visible
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import net.frozenbit.games.soundgame.theme.Dimensions
import net.frozenbit.games.soundgame.theme.Shapes
import net.frozenbit.games.soundgame.theme.Typography
import net.frozenbit.games.soundgame.viewmodels.presentation.SoundCreation

@Composable
fun SoundCreationBox(
    option: SoundCreation,
    modifier: Modifier = Modifier,
    bottomSlot: @Composable (() -> Unit)? = null,
) {
    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(Dimensions.Host.mediumInnerPadding),
        modifier = modifier,
    ) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(4.dp),
            modifier = Modifier
                .alpha(if (option.highlighted) 1f else 0.5f)
                .background(
                    MaterialTheme.colorScheme.primary,
                    Shapes.Host.mediumContainer,
                )
                .padding(Dimensions.Host.mediumInnerPadding)
                .widthIn(max = 200.dp)
        ) {
            AudioWaveForm(
                playing = option.play1Indicator,
                barColor = Color.White,
                modifier = Modifier
                    .fillMaxWidth()
                    .height(48.dp)
            )
            Text(
                option.line1,
                color = Color.White,
                style = Typography.Host.small,
                textAlign = TextAlign.Center,
                modifier = Modifier
                    .visible(option.line1Visible)
            )
            HorizontalDivider(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(1.dp)
                    .visible(false)
            )
            AudioWaveForm(
                playing = option.play2Indicator,
                barColor = Color.White,
                modifier = Modifier
                    .fillMaxWidth()
                    .height(48.dp)
            )
            Text(
                option.line2,
                color = Color.White,
                style = Typography.Host.small,
                textAlign = TextAlign.Center,
                modifier = Modifier
                    .visible(option.line2Visible)
                    .padding(
                        bottom = Dimensions.Host.mediumInnerPadding,
                    )
            )
        }
        bottomSlot?.let { it() }
    }
}
